import { render, staticRenderFns } from "./Kepemilikan.vue?vue&type=template&id=454323e1"
import script from "./Kepemilikan.vue?vue&type=script&lang=js"
export * from "./Kepemilikan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports